<template>
	<div class="marketingManagement-body">
		<div class="fx-header">
			<p>商品预售</p>
		</div>
		<Search @handleSearch="handleSearch"></Search>
		<div class="btn-box1">
			<div style="min-height:60px;display :flex;align-items :center">
				<el-button
					type="primary"
					size="small "
					v-if="AuthorityList['08_0004_0003_00']"
					@click="addClick"
					icon="el-icon-plus"
					>新增活动
				</el-button>
				<el-button
					type="primary"
					class="search-btn fx-big-btn"
					size="small "
					v-if="AuthorityList['08_0004_0004_00']"
					@click="delClick(true)"
					plain>删除
				</el-button>
			</div>
        </div>
		<div class="main-table-box">
			<el-table
			:stripe='true'
			size='mini'
			class="grid-content"
			@row-dblclick='rowClick'
			:data="tableData"
			:height="tableHeight"
			border
			@selection-change="handleSelectionChange"
			ref="table">
			<el-table-column
			type="selection"
			align="center"
			fixed="left"
			width="50">
			</el-table-column>
			<el-table-column
				prop="code"
				key="code"
				label="活动编号"
				align="center"
				min-width="250">
			</el-table-column>
			<el-table-column
				prop="name"
				key="name"
				label="活动名称"
				align="center"
				min-width="250">
			</el-table-column>
			<el-table-column
				prop="disabledFlag"
				key="disabledFlag"
				label="活动状态"
				align="center"
				min-width="100">
				<template slot-scope='scope'>
					<div>{{scope.row.disabledFlag ? '停用' : '启用'}}</div>
				</template>
			</el-table-column>
			<!-- <el-table-column
				prop="discountState"
				key="discountState"
				label="预售状态"
				align="center"
				min-width="100">
				<template slot-scope='scope'>
					<div v-if="scope.row.discountState === 1">未开始</div>
					<div v-if="scope.row.discountState === 0">进行中</div>
					<div v-if="scope.row.discountState === 2">已结束</div>
				</template>
			</el-table-column> -->
			<el-table-column
				label="适用客户"
				align="center"
				min-width="100">
				<template slot-scope='scope'>
					<div>{{scope.row.attendway === 0 ? '全部客户' : '部分客户'}}</div>
				</template>
			</el-table-column>
			<el-table-column
				label="适用门店"
				align="center"
				min-width="100">
				<template slot-scope='scope'>
					<div>{{scope.row.shopattendway === 0 ? '全部店铺' : '部分店铺'}}</div>
				</template>
			</el-table-column>
			<el-table-column
				label="活动时间"
				align="center"
				min-width="300">
				<template slot-scope='scope'>
					<div>{{scope.row.beginDate}}——{{scope.row.endDate}}</div>
				</template>
			</el-table-column>
			<el-table-column
				label="预计发货时间"
				align="center"
				min-width="300">
				<template slot-scope='scope'>
					<div>{{scope.row.presaleBeginDate}}——{{scope.row.presaleEndDate}}</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="productAmount"
				label="预售商品数量"
				align="center"
				min-width="120">
			</el-table-column>
			<el-table-column label="操作" min-width="200" align="center">
				<template slot-scope="scope">
					<el-button  type='text' size="mini" v-if="AuthorityList['08_0004_0005_00'] && scope.row.disabledFlag" @click='statusChange(scope.row, false)'>启用</el-button>
					<el-button  type='text' size="mini" v-if="AuthorityList['08_0004_0005_00'] && !scope.row.disabledFlag" @click='statusChange(scope.row, true)'>停用</el-button>
					<el-button  type='text' size="mini" icon="el-icon-edit" v-if="AuthorityList['08_0004_0002_00']" @click='modifyClick(scope.row)'>编辑</el-button>
					<el-button  type='text' size="mini" icon="el-icon-delete" v-if="AuthorityList['08_0004_0004_00']" @click='delClick(false,scope.row)'>删除</el-button>
				</template>
			</el-table-column>
			</el-table>
		</div>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.number"
            :page-sizes="[20, 40, 60, 100, 300]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
		<el-dialog
			title="提示"
			class="dialog-title"
			:visible.sync="showError"
			width="600px">
			<div style="width: 100%;max-height: 300px;overflow-y:auto;">
				<div style="padding: 5px 10px;text-align: left;" v-for="(item,index) in errorList" :key='index'>
					{{item}}
				</div>
			</div>
			<div style="text-align:center" slot="footer">
				<el-button type="primary" size="mini" @click="closeError">知道了</el-button>
			</div>
		</el-dialog>
    </div>
</template>
<script>
import Search from '@/components/preSaleList/Search.vue'
export default {
	name: 'preSaleList',
	components: {
		Search
	},
	data () {
		return {
			code: '',
			name: '',
			dateValue: [],
			dateValue1: [],
			discountState: -1,
			disabledFlag: -1,
			AuthorityList: {
				'08_0004_0001_00': false,
				'08_0004_0002_00': false,
				'08_0004_0003_00': false,
				'08_0004_0004_00': false,
				'08_0004_0005_00': false
			},
			tableData: [],
			tableHeight: '100%',
			total: 0,
			ids: [],
			page: {
				number: 1,
				size: 20
			},
			showError: false,
			errorList: []
		}
	},
	created () {
		this.tableReload()
		this.getAuthority('08_0004_0000_00')
	},
	methods: {
		statusChange (row, flag) {
			let params = {
				discountids: row.id,
				disabledflag: flag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/presale/update/disabledflag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('操作成功')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		closeError () {
			this.showError = false
		},
		delClick (flag, row) {
			if (flag) {
				if (this.ids.length === 0) {
					this.$message.error('至少选则一条活动')
					return false
				}
			}
			let list = this.ids.map(item => {
				return item.id
			})
			// let logger = null
			// let name = ''
			// if (flag) {
			// 	let arr = []
			// 	this.ids.forEach(item => {
			// 		let name = '【' + item.code + '】' + '【' + item.name + '】'
			// 		arr.push(name)
			// 	})
			// 	name = arr.join(',')
			// } else {
			// 	name = '【' + row.code + '】' + '【' + row.name + '】'
			// }
			// logger = this.$fxLogger.createInfo('discount.discount_info.delete', { name: name })
			let params = {
				discountids: flag ? list.join(',') : row.id,
				type: 2
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/delete`,
				data: params
				// logger
			}).then(res => {
				if (!res.result) {
					this.errorList = []
					this.errorList = res.data
					this.showError = true
					return false
				} else {
					this.$message.success('删除成功！')
					this.tableReload()
				}
			})
		},
		handleSelectionChange (val) {
			this.ids = val
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		addClick () {
			window.sessionStorage.removeItem('preSaleId')
			this.$router.push('preSaleDetail')
		},
		rowClick (row, column, event) {
			this.modifyClick(row)
		},
		modifyClick (row) {
			window.sessionStorage.setItem('preSaleId', row.id)
			this.$router.push('preSaleDetail')
		},
		getTableDataHandle (data) {
			this.tableData = data.recordList
			this.total = data.recordCount
		},
		handleSearch (data) {
			this.page.number = 1
			this.page.size = 20
			this.code = data.code
			this.name = data.name
			this.dateValue = data.dateValue
			this.dateValue1 = data.dateValue1
			this.discountState = data.discountState
			this.disabledFlag = data.disabledFlag
			this.tableReload()
		},
		tableReload () {
			let params = {
				code: this.code,
				name: this.name,
				beginDate: this.dateValue.length > 0 ? this.dateValue[0] : '',
				endDate: this.dateValue.length > 0 ? this.dateValue[1] : '',
				presaleBeginDate: this.dateValue1.length > 0 ? this.dateValue1[0] : '',
				presaleEndDate: this.dateValue1.length > 0 ? this.dateValue1[1] : '',
				discountState: this.discountState,
				disabledFlag: this.disabledFlag,
				page: this.page.number,
				size: this.page.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/presale/list`,
				data: params
			}).then(res => {
				this.tableData = res.recordList
				this.total = res.recordCount
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>

.marketingManagement-body{
    display: flex;
    min-width :1000px;
    width :100%;
	flex-direction: column;
    height :100%;
    overflow-y :auto;
    padding-bottom :50px;
    border-radius :0px 0px 10px 10px;
	.btn-box1{
		justify-content: space-between;
		display: flex;
		align-items: center
	}
	.main-table-box {
		flex: 1
		padding-bottom 10px
		overflow-y: auto;
	}
	.rule-box{
		width:100%;
		text-align:center;
		padding: 0 10px;
		overflow :hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	.point{
		width:6px;
		height:6px;
		border-radius:50%;
		margin-right:10px;
	}
	.point-box{
		display :flex;
		align-items:center;
		justify-content :center
	}
}

</style>
<style lang="stylus">
.marketingManagement-body {
	.cell{
		padding :0px !important
	}
	.detail-dialog-title {
		.el-dialog__header {
			display: none
		}
		.el-dialog__title {
			padding-left 10px;
			border: none !important;
		}
	}
	.showPicDialog{
		.el-dialog__header {
			border-bottom:1px solid #eee;
			padding: 20px 0px 10px;
			text-align: left;
		}
	}
	.customerDialog{
		.el-dialog__header {
			margin :0px 20px;
			padding :10px 0px;
			border-bottom:1px solid #eee;
			text-align: left;
		}
		.el-dialog__body{
			padding: 10px 20px 10px 20px;
		}
		.name-input .el-input-group__append{
			background-color:var(--fx-primary-color);
			color:#FFFFFF
		}
	}
	.subordinateDialog{
		.el-dialog__body{
			padding :0px 20px;
		}
		.el-dialog__header {
			display :none
		}
		.blue-line{
			height :20px;
			width: 5px;
			background-color :var(--fx-primary-color);
			margin-right :10px;
		}
		.title{
			font-size:16px;
			justify-content: space-between;
			font-weight: bold;
			display :flex;
			flex-direction :row;
			border-bottom:1px solid #eee;
			padding: 20px 0px 10px;
			text-align: left;
			margin-bottom :5px;
			.close{
				cursor: pointer;
				width: 20px;
				height: 20px;
				display :flex;
				align-items :center;
				justify-content :center;
				color :white;
				border-radius: 50%;
				background-color: #f00;
				line-height: 21px;
				font-weight: bold;
			}
		}
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.alert-dialog{
		.el-dialog__title {
			padding-left 10px;
			border: none !important;
			float : left !important;
		}
		.el-dialog__body{
			padding:20px 20px 20px 20px
		}
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: #FFFFFF !important;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:black !important;
			}
		}
	}
	.el-dialog__body{
		padding:10px 20px 0px 20px
	}


}
</style>
